
import { useEffect } from 'react';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const Denver = () => {
  const nearbyFacilities = [
    { name: 'Suncor Energy Commerce City', type: 'Refinery', capacity: '98,000 BPD' },
    { name: 'Phillips 66 Wood River', type: 'Refinery', capacity: '336,000 BPD' },
    { name: 'Manufacturing Facilities', type: 'Industrial', capacity: '50+ Facilities' },
    { name: 'Energy Facilities', type: 'Oil & Gas', capacity: 'Major Operations' }
  ];

  const faqData = [
    {
      question: "Do you buy valves from Denver area refineries?",
      answer: "Yes, we purchase surplus valves, Fisher control valves, and instrumentation from Denver area refineries including Suncor Energy Commerce City and regional manufacturing facilities. We provide 6-8 hour response times with competitive pricing for Colorado facilities."
    },
    {
      question: "What types of equipment do you buy in Denver?",
      answer: "We buy control valves, ball valves, gate valves, globe valves, heat exchangers, pumps, compressors, safety systems, Rosemount transmitters, flow meters, analyzers, and controllers from Denver area refineries and industrial facilities."
    },
    {
      question: "How quickly can you respond to Denver facilities?",
      answer: "We provide 6-8 hour response times for Denver and surrounding Colorado facilities. Our team has 20+ years of experience serving Colorado's diverse industrial and energy sectors."
    },
    {
      question: "Do you purchase equipment from Denver manufacturing plants?",
      answer: "Yes, we buy industrial equipment and instrumentation from Denver's 50+ manufacturing facilities. We provide professional valuations for process equipment and control systems throughout the Rocky Mountain region."
    },
    {
      question: "What valve brands do you buy from Denver facilities?",
      answer: "We purchase Fisher, Masoneilan, Flowserve, Cameron, Rosemount, Emerson, Honeywell, and other major brands from Denver refineries, manufacturing plants, and industrial facilities."
    },
    {
      question: "Do you serve other Colorado cities from Denver?",
      answer: "Yes, our Denver service area covers all of Colorado and surrounding Rocky Mountain states. We provide fast response times throughout the region including Wyoming and Utah industrial facilities."
    }
  ];

  const schemaData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": "https://valvesalessupply.com/denver",
        "url": "https://valvesalessupply.com/denver",
        "name": "Denver Valve Buyers Colorado | Rocky Mountain Equipment",
        "description": "Professional valve buyers in Denver serving Colorado industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.",
        "breadcrumb": {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Denver",
              "item": "https://valvesalessupply.com/denver"
            }
          ]
        }
      },
      {
        "@type": "LocalBusiness",
        "name": "Valve Sales Supply - Denver",
        "image": "https://valvesalessupply.com/logo.png",
        "@id": "https://valvesalessupply.com/denver",
        "url": "https://valvesalessupply.com/denver",
        "telephone": "214-854-5638",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Denver",
          "addressRegion": "CO",
          "addressCountry": "US"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": 39.7392,
          "longitude": -104.9903
        },
        "areaServed": {
          "@type": "City",
          "name": "Denver",
          "containedIn": {
            "@type": "State",
            "name": "Colorado"
          }
        },
        "serviceType": ["Industrial Valve Buyers", "Refinery Equipment Buyers", "Manufacturing Equipment", "Energy Equipment"]
      },
      {
        "@type": "FAQPage",
        "mainEntity": faqData.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      }
    ]
  };

  useEffect(() => {
    // Set page title
    document.title = "Denver Valve Buyers Colorado | Rocky Mountain Equipment";
    
    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional valve buyers in Denver serving Colorado industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Professional valve buyers in Denver serving Colorado industrial facilities. We purchase surplus valves, control systems, and instrumentation at above scrap rates. Call 214-854-5638.';
      document.head.appendChild(meta);
    }
    
    // Update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.setAttribute('name', 'keywords');
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute('content', 'valve buyers Denver, Colorado equipment, surplus valves, Fisher control valves, Rocky Mountain equipment');

    // Add canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', 'https://valvesalessupply.com/denver');

    // Add Open Graph tags
    const ogTags = [
      { property: 'og:title', content: 'Denver Valve Buyers Colorado | Rocky Mountain Equipment' },
      { property: 'og:description', content: 'Professional valve buyers in Denver serving Colorado industrial facilities.' },
      { property: 'og:url', content: 'https://valvesalessupply.com/denver' },
      { property: 'og:type', content: 'website' }
    ];

    ogTags.forEach(tag => {
      let meta = document.querySelector(`meta[property="${tag.property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', tag.property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add geo tags
    const geoTags = [
      { name: 'geo.position', content: '39.7392;-104.9903' },
      { name: 'geo.placename', content: 'Denver, Colorado' },
      { name: 'geo.region', content: 'US-CO' }
    ];

    geoTags.forEach(tag => {
      let meta = document.querySelector(`meta[name="${tag.name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', tag.content);
    });

    // Add Schema.org structured data
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript && existingScript.textContent === JSON.stringify(schemaData)) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-900 to-slate-800 text-white py-20">
        <div className="max-w-6xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              <span className="text-blue-300">We Buy Valves Denver</span>
            </h1>
            <p className="text-xl text-blue-100 max-w-3xl mx-auto">
              Serving Colorado's **Rocky Mountain industrial facilities** with professional equipment evaluations. 
              We purchase **surplus valves**, control systems, and instrumentation at competitive rates.
            </p>
            <div className="mt-8">
              <a href="tel:214-854-5638" className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200">
                Call Now: **214-854-5638**
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Service Area Stats */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-3xl font-bold text-blue-600 mb-2">4</h3>
              <p className="text-gray-600">Major Industrial Facilities</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-3xl font-bold text-green-600 mb-2">6-8 Hours</h3>
              <p className="text-gray-600">Response Time</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg">
              <h3 className="text-3xl font-bold text-orange-600 mb-2">20+ Years</h3>
              <p className="text-gray-600">Industry Experience</p>
            </div>
          </div>
        </div>
      </section>

      {/* Major Facilities */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            **Major Industrial Facilities** We Serve
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {nearbyFacilities.map((facility, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-blue-500">
                <h3 className="font-bold text-lg mb-2 text-gray-800">**{facility.name}**</h3>
                <p className="text-blue-600 font-semibold mb-1">{facility.type}</p>
                <p className="text-gray-600">{facility.capacity}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Equipment We Buy */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            Equipment We Purchase in **Denver**
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold mb-6 text-blue-600">**Control & Safety Systems**</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Fisher Control Valves** (All Series)
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Masoneilan** Control Systems
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Safety Relief Valves** & Systems
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Emergency Shutdown** Systems
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Process Controllers** & Actuators
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h3 className="text-2xl font-bold mb-6 text-orange-600">**Instrumentation & Measurement**</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Rosemount Transmitters** (All Models)
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Flow Meters** & Measurement Systems
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Pressure Gauges** & Transmitters
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Analyzers** & Testing Equipment
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-3"></i>
                  **Temperature Controllers** & Sensors
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
            Frequently Asked Questions - **Denver**
          </h2>
          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-lg">
                <h3 className="text-lg font-bold text-blue-600 mb-3">**{faq.question}**</h3>
                <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-6">
            Ready to Sell Your **Industrial Equipment**?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Get a professional evaluation from Colorado's **trusted equipment buyers**
          </p>
          <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
            <a href="tel:214-854-5638" className="block sm:inline-block bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200">
              Call **214-854-5638**
            </a>
            <Link to="/contact" className="block sm:inline-block bg-white hover:bg-gray-100 text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold transition-colors duration-200">
              Request Quote
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Denver;
